import { render, staticRenderFns } from "./EditShifts.vue?vue&type=template&id=12fb458e&"
import script from "./EditShifts.vue?vue&type=script&lang=js&"
export * from "./EditShifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports